/* eslint-disable no-debugger */
/* eslint-disable no-console */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable prefer-arrow-callback */

import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import Radio from "@mui/material/Radio";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./AdditionalAccess.module.css";
import {
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField,
} from "../FormComponents";
import {
  MESSAGE_TYPE,
  RESOURCE_TYPE,
} from "../../constants";
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { withAllowedOperationsProvider } from "../../hocs";
import {
  fetchChassis,
  setChassisData,
  getInvoice,
} from "../../redux/actions/productsActions";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import MultiSelects from "../FormComponents/MultiSelects";
import { setLogin } from '../../redux/features/auth/actions';
import Truckloading from "../CvLoader/Cvloader";
import { sanitizeNumeric } from "../../utils/utils";
import apiService from "../../apis/apiService";


function AccessControlForm({
  baseUrl,
  auth,
}) {
  
  const [loadingTruck, setLoadingTruck] = React.useState(false);
  const history = useHistory();
  const dispatchNew= useDispatch();
  const { showPopup } = usePopupManager();
  let {
    personNumber,
    userRole,
    apiSendData
  } = auth;

  const [BCDetails, setBCDetails] = useState([]);
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const [userRemark, setUserRemark] = useState("");
  const [bcRemark, setBcRemark] = useState("");
  const [SARemark, setSARemark] = useState("");
  const [eDetails, setEDetails] = useState("");
  const [apiPayloadData, setAPIPaylodData] = useState(apiSendData);

  const [role, setRole] = useState([
    { value: "DS", label: "Departmental SPOC" },
    { value: "SUP", label: "Supervisor" },
  ]);
  const [onChange, setOnChange] = useState(false);
  const [dropDownValue, setDropDownValue] = useState([]);
  const [disableButton,setDisableButton]=useState(false)
  const [currentUserData, setCurrentUserData] = useState([]);
  const [newUserData, setNewUserData] = useState({});
  const [existingBC, setExistingBC] = useState([]);

  const [currentTicket, setCurrentTicket] = useState("");
  const [newAccessTicket, setNewAccessTicket] = useState("");
  const hasSARole = userRole.includes("SA");
  const [disableTicketNumber, setDisableTicketNumber] = useState(false);
  const[requestTypes,setRequestTypes]=useState([]);
  

  
  const renderTicketEmpDetails = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>
        {loadingTruck ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>):
          // <CustomFormGroup header="Report Details" body={renderReport()} />
          <> <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket: emp_app_details[0]?.pers_no || "",
                empName: emp_app_details[0]?.employee_name || "",
                bcNo: emp_app_details[0]?.bc_no || "",
                bcDesc: emp_app_details[0]?.costcenter_name || "",
                workArea: emp_app_details[0]?.workarea || "",
                requestId: request_type.activeId
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_35",
              "Employee Name_80",
              "BC No_38",
              "BC Description_120",
              "Work Area_80",
              "Request Id_50"
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid></>
        }
       
      </Grid>
    </div>
  );

  const renderTransferEmpDetails = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                type: "Current",
                ticket: currentUserData?.pers_no || "",
                empName: currentUserData?.employee_name || "",
                bcNo: currentUserData?.bc_no || "",
                bcDesc: currentUserData?.costcenter_name || "",
                workArea: currentUserData?.workarea || "",
              },
              {
                type: "Propose",
                ticket: newUserData.pers_no ?? "",
                empName: newUserData.employee_name ?? "",
                bcNo: newUserData.bc_no ?? "",
                bcDesc: newUserData.costcenter_name ?? "",
                workArea: newUserData.workarea ?? "",
              },
            ]}
            tableHeaderLabel={[
              "_30 ",
              "Ticket No_40",
              "Employee Name_100",
              "BC No._60",
              "BC Description_100",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderTicketApprovalDetailsDelete = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Approval Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.bc_head_persno || ""
                    : newUserData?.bc_head_persno || "",
                empName:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.bchead_name || ""
                    : newUserData?.bchead_name || "",
                bcNo:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.bc_no || ""
                    : newUserData?.bc_no || "",
                bcDesc:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.costcenter_name || ""
                    : newUserData?.costcenter_name || "",
                workArea:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.workarea || ""
                    : newUserData?.workarea || "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_40",
              "Employee Name_150",
              "BC No._60",
              "BC Description_150",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderTicketBcDetails = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>BC Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                workArea:
                  removeDeleteIdentifier === "remove"
                    ? requestBcDetails?.workarea || ""
                    : requestBcDetails[0]?.workarea || "",
                location:
                  removeDeleteIdentifier === "remove"
                    ? requestBcDetails?.location || ""
                    : requestBcDetails[0]?.location || "",
                bcNo:
                  removeDeleteIdentifier === "remove"
                    ? requestBcDetails?.description || ""
                    : requestBcDetails[0]?.description || "",
              },
            ]}
            tableHeaderLabel={["Work Area_70", "Location_30", "Description_120"]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const request_type = useParams();
  const [disable, setDisable] = useState(false);
  const [removeDeleteIdentifier, setRemoveDeleteIdentifier] = useState("");
  const [requestRole, setRequestRole] = useState("");
  const [requestBcDetails, setRequestBcDetails] = useState([]);

  useEffect(() => {
    const getRequestType = async()=>{
      if (request_type.requestType != undefined) {
        setDisable(true);
        let value = {};
        const parts = request_type.requestType.split("-");
        setRequestType(parts[1]);
        setRequestRole(parts[2]);
        if (parts[2] === "SUP") {
          value = { value: parts[2], label: "Supervisor" };
        }
        if (parts[2] === "DS") {
          value = { value: parts[2], label: "Departmental SPOC" };
        }
        setDropDownValue(value);
        const data = {
          request_id: request_type.activeId,
        };
        if (request_type.requestType === "AA-NA-SUP") {  
          try {
            const response = await apiService.GetAdditionalAccessRequestDetails(data, dispatchNew)
            if(response?.["msg"] === "Success"){
              dispatchNew(setLogin({...auth, recentStatus: response.status}))
              dispatchNew(setLogin({...auth, recentStatus: response.status}))
              setEmp_app_details(response?.data);
              }
          } catch (error) {
            dispatchNew(setLogin({ ...auth, recentStatus: error?.response?.status }));
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
            });
          }      
        }
        if (request_type.requestType === "AA-RTA-SUP") {
          try {
            const response = await apiService.GetAdditionalAccessRequestDetails(data, dispatchNew)
            if(response?.["msg"] === "Success"){
              if (response?.data[0].trans_pers_no === null) {
                setRemoveDeleteIdentifier("remove");
                setCurrentUserData(response?.data[0]);
              } else {
                setRemoveDeleteIdentifier("transfer");
                const apiData = response?.data;
                const currentUser = apiData.find(
                  (item) => item.pers_no != response?.data[0]?.trans_pers_no
                );
                const newUser = apiData.find(
                  (item) => item.pers_no === response?.data[0]?.trans_pers_no
                );
                setCurrentUserData(currentUser);
                setNewUserData(newUser);
              }
            }
          } catch (error) {
            dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
            });
          }       
        }
        if (request_type.requestType === "AA-NA-DS") {
          try {
            const response = await apiService.GetAdditionalAccessRequestDetails(data, dispatchNew)
            if(response["msg"] === "Success"){
              dispatchNew(setLogin({...auth, recentStatus: response.status}))
              setEmp_app_details(response?.data?.user_details);
              setRequestBcDetails(response?.data?.bc_details);
            }
          } catch (error) {
            dispatchNew(setLogin({ ...auth, recentStatus: error?.response?.status }));
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
            });
          }      
        }
        if (request_type.requestType === "AA-RTA-DS") {
          try {
            const response = await apiService.GetAdditionalAccessRequestDetails(data, dispatchNew)
            if(response?.["msg"] === "Success"){
              dispatchNew(setLogin({...auth, recentStatus: response.status}))
              if (response?.data?.user_details[0].trans_pers_no === null) {
                setRemoveDeleteIdentifier("remove");
                setCurrentUserData(response?.data?.user_details[0]);
                setRequestBcDetails(response?.data?.bc_details[0]);
              } else {
                setRemoveDeleteIdentifier("transfer");
                const apiData = response?.data?.user_details;
                const currentUser = apiData.find(
                  (item) =>
                    item.pers_no != response?.data?.user_details[0].trans_pers_no
                );
                const newUser = apiData.find(
                  (item) =>
                    item.pers_no === response?.data?.user_details[0].trans_pers_no
                );
                setCurrentUserData(currentUser);
                setNewUserData(newUser);
                setRequestBcDetails(response?.data?.bc_details);
              }
            }
          } catch (error) {
            dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
            });
          }     ;
        }
      }
    }
    getRequestType()
  }, [request_type.requestType]);

  const [emp_app_details, setEmp_app_details] = useState([]);
  const [emp_app_details_status, setEmp_app_details_status] = useState();
  const [tableData, setTableData] = useState([]);
  const [requestType, setRequestType] = useState("");

  useEffect(() => {
    setEmp_app_details([]);
    setCurrentUserData([]);
    setCurrentTicket("");
    setNewUserData({});
    setNewAccessTicket("");
    setEmp_app_details_status();
    setEDetails("");
  }, [requestType, dropDownValue.value]);

  const [myState, setState] = React.useState({
    poNo: "",
    stmNo: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false,
    checkBox: true,
  });

  const [selectedBC, setSelectedBC] = useState([]);
  const [accessRole, setUserRole] = useState(userRole);

  useEffect(()=>{
    setCurrentTicket(personNumber)
  },[personNumber])

  useEffect(() => {
    if (hasSARole === false) {
      if (request_type.requestType === undefined) {
        if (dropDownValue.value === "SUP" && requestType === "NA") {
          setDisableTicketNumber(true);
          setEDetails(personNumber);
        } else if (dropDownValue.value === "SUP" && requestType === "RTA") {
          setDisableTicketNumber(true);
          setCurrentTicket(personNumber);
        } else if (dropDownValue.value === "DS" && requestType === "NA") {
          setDisableTicketNumber(true);
          setEDetails(personNumber);
        } else if (dropDownValue.value === "DS" && requestType === "RTA") {
          setDisableTicketNumber(true);
          setCurrentTicket(personNumber);
        }
      }
    }
  }, [dropDownValue.value, requestType,personNumber]);

  const renderSpocApproval = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Approval Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={selectedBCInfo?.map((info, index) => ({
              bcDetails: info.bc_details,
              department_head: info.department_head,
            }))}
            tableHeaderLabel={["BC Details", "Department Head"]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderDetails = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Approval Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket: emp_app_details[0]?.bc_head_pers_no || "",
                empName: emp_app_details[0]?.bc_head_name || "",
                bcNo: emp_app_details[0]?.bc_no || "",
                bcDesc: emp_app_details[0]?.costcenter_name || "",
                workArea: emp_app_details[0]?.workarea || "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_40",
              "Employee Name_150",
              "BC No._60",
              "BC Description_150",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderApprovalDetailsDelete = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Approval Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.bc_head_persno || ""
                    : newUserData?.bc_head_persno || "",
                empName:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.bchead_name || ""
                    : newUserData?.bchead_name || "",
                bcNo:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.bc_no || ""
                    : newUserData?.bc_no || "",
                bcDesc:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.costcenter_name || ""
                    : newUserData?.costcenter_name || "",
                workArea:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.workarea || ""
                    : newUserData?.workarea || "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_40",
              "Employee Name_150",
              "BC No._60",
              "BC Description_150",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderroledetails = () => (

    <div className={styles.formGroup}>
      <Grid container spacing={1} className={styles.myGrid} columns={12} style={{marginTop:'10px'}}>
        <Grid item md={3} lg={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label className={styles.spanClass}>Role</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isDisabled='true'
                className={clsx(styles.select, styles.sel2)}
                isMulti={false}
                options={role}
                value={dropDownValue}
                onChange={(e) => {
                  setDropDownValue(e);
                  setOnChange(true);
                  setDisableButton(false)
                  setNewAccessTicket("")
                  setSelectedBC([])
                  setError('')
                }}
                name="type"
              />
            </div>
          </div>
        </Grid>

        <Grid item md={6} lg={6} sm={2}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv_radio}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                markIfUnselected={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                style={{
                  marginLeft: "15px",
                }}
                value={requestType}
                defaultValue=""
              >
                <FormControlLabel
                  value="NA"
                  name="New Access"
                  control={<Radio size="small" disabled={'ture'} />}
                  label="New Access"
                  className={styles.radiobtn}
                />
              </RadioGroup>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                markIfUnselected={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                value={requestType}
                defaultValue=""
              >
                <FormControlLabel
                  value="RTA"
                  name="Transfer Access"
                  control={<Radio size="small" disabled={'true'} />}
                  label="Transfer Access / Delete Access"
                  style={{ color: "black" }}
                  className={styles.radiobtn}
                />
              </RadioGroup>
            </div>
          </div>
        </Grid>
        {requestId !== "" && dropDownValue.value === "SUP" && (
          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label className={styles.spanClass}>
                  Request Id : {requestId}
                </label>
              </div>
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );

  const RTA = async() => {
    setLoadingTruck(false)
    let data = {};
    if (currentTicket != "" && newAccessTicket === "") {
      data = {
        pers_no: sanitizeNumeric(currentTicket),
        trans_pers_no: null,
        operation_flag: "AA",
        suboperation_flag: requestType,
        erole: dropDownValue.value,
      };
      if (currentTicket.length == 6) {
        try {
          const response = await apiService.GetAdditionalAccessRequestDetails(data, dispatchNew)
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          setEmp_app_details_status(response?.msg);
          let lowercaseMsg = response?.msg.toLowerCase();
          
          if (lowercaseMsg === "fail") {
            setLoadingTruck(false)
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: response?.data,
              reloads: true,
            });

          } else {
            if (dropDownValue.value === "SUP") {
              if(lowercaseMsg==='success') {
                setLoadingTruck(false)
              
              // if no bc person name 

            let noBCHeadTrans=false
             let noBcHeadNameTrans=false
             if(response?.data){ 
              noBCHeadTrans =response?.data[0]?.bc_head_persno==null
              noBcHeadNameTrans=response?.data[0]?.bchead_name==null
             }
            
             if(noBCHeadTrans  || noBcHeadNameTrans){
              setLoadingTruck(false)
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                 contextText: MESSAGE_TYPE.INFORMATION,
                 info: 'No Approving Authority request you to contact SBP team',
               });
               setDisableButton(true)
               setCurrentUserData(response?.data)
             }
            else{
              setCurrentUserData(response?.data)
            }
            }}
            if (dropDownValue.value === "DS") {
              if(lowercaseMsg==='success') {
                  setLoadingTruck(false)
                  setCurrentUserData(response?.data?.emp_details);
                  setBCDetails(response?.data?.bc_details);
                  const bcList = response?.data.bc_details;
                  const transformedData = bcList.map((item) => ({
                  value: item.bc_number,
                  label: item.bc_details,
                  }));
                  setExistingBC(transformedData);
              }
          }}
        } catch (error) {
          dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
          if (error.response && error.response.status === 403) {
            console.error("Forbidden (403) error occurred. You may not have permission for this operation.");
          }
        }
      }
    } else {
      data = {
        pers_no: sanitizeNumeric(currentTicket),
        trans_pers_no: sanitizeNumeric(newAccessTicket),
        operation_flag: "AA",
        suboperation_flag: requestType,
        erole: dropDownValue.value,
      };

      if (newAccessTicket.length == 6 && currentTicket.length == 6) {
        try {
          const response = await apiService.GetAdditionalAccessRequestDetails(data, dispatchNew) 
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
            setEmp_app_details_status(response?.msg);
            let lowercaseMsg = response?.msg.toLowerCase();
            
            if (lowercaseMsg === "fail") {
              setLoadingTruck(false)
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: response?.data,
                reloads: true,
              });
              setCurrentUserData([])
              setNewUserData([])
              setExistingBC([])
            }
            
            else {
                if (dropDownValue.value === "SUP") {
                  if(lowercaseMsg==='success') {
                    setLoadingTruck(false)
                  
                  const apiData = response?.data;
                  let noBCHeadTrans=false
                  let noBcHeadNameTrans=false
                  if(response.data){ 
                    const apiDataSup=response?.data;
                    const currentUserSup = apiDataSup.find(
                      (item) => item.pers_no === newAccessTicket
                    );
                   noBCHeadTrans =currentUserSup?.bc_head_persno==null
                   noBcHeadNameTrans=currentUserSup?.bchead_name==null

                   if(noBCHeadTrans  || noBcHeadNameTrans){
                    setLoadingTruck(false)
                    showPopup({
                      type: MESSAGE_TYPE.INFORMATION,
                       contextText: MESSAGE_TYPE.INFORMATION,
                       info: 'No Approving Authority request you to contact SBP team',
                       reloads: true,
                     });
                     setDisableButton(true)
                   }
                  }

                  const currentUser = apiData.find(
                    (item) => item.pers_no === currentTicket
                  );
                  const newUser = apiData.find(
                    (item) => item.pers_no === newAccessTicket
                  );

                  setCurrentUserData(currentUser);
                  setNewUserData(newUser);
                  if(currentUser?.location !== newUser?.location){
                    showPopup({
                      type: MESSAGE_TYPE.INFORMATION,
                      contextText: MESSAGE_TYPE.INFORMATION,
                      info: "Proposed ticket number is from different location",
                      reloads: true,
                    });
                  }
                }}
                if (dropDownValue.value === "DS") {
                  if(lowercaseMsg==='success') {
                    setLoadingTruck(false)
                    let noBCHeadTrans=false
                    let noBcHeadNameTrans=false
                    if(response?.data){ 
                      const apiDataDs = response?.data?.emp_details;
                      const newUser = apiDataDs.find(
                        (item) => item.pers_no === newAccessTicket
                      );
                     noBCHeadTrans =newUser?.bc_head_pers_no==null
                     noBcHeadNameTrans=newUser?.bc_head_name==null
      
                     if(noBCHeadTrans  || noBcHeadNameTrans){
                      setLoadingTruck(false)
                      showPopup({
                        type: MESSAGE_TYPE.INFORMATION,
                         contextText: MESSAGE_TYPE.INFORMATION,
                         info: 'No Approving Authority request you to contact SBP team',
                         reloads: true,
                       });
                       setDisableButton(true)
                     }
                    }
                  const transformedData = Object.values(
                    response?.data?.bc_details
                  ).map((item) => ({
                    value: item.bc_number,
                    label: item.bc_details,
                  }));
                  setExistingBC(transformedData);
                  const apiData = response?.data?.emp_details;
                  const currentUser = apiData.find(
                    (item) => item.pers_no === currentTicket
                  );
                  const newUser = apiData.find(
                    (item) => item.pers_no === newAccessTicket
                  );
                  setCurrentUserData(currentUser);
                  setNewUserData(newUser);
                }
              }} 
        } catch (error) {
          dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
        }         
      }
    }
  };

  useEffect(() => {
    RTA();
  }, [newAccessTicket, currentTicket]);


  const renderOther1 = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                type: "Current",
                ticket: (
                  <ValidatingTextField
                    variant="outlined"
                    size="small"
                    isDisabled='true'
                    value={currentTicket}
                    name="Ticket Number"
                    inputProps={{
                      "data-testid": "remark-input",
                    }}
                    style={{ width: "100%" }}
                  />
                ),
                empName:  
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.employee_name || ""
                    : currentUserData?.employee_name || "",
                bcNo:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.bc_no || ""
                    : currentUserData?.bc_no || "",
                bcDesc:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.costcenter_name || ""
                    : currentUserData?.costcenter_name || "",
                workArea:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.workarea || ""
                    : currentUserData?.workarea || "",
              },
              {
                type: "Propose",
                ticket: (
                  <ValidatingTextField
                  isDisabled='true'
                    variant="outlined"
                    size="small"
                    name="Ticket Number" 
                    inputProps={{
                      "data-testid": "remark-input",
                    }}
                    style={{ width: "100%" }}
                  />
                ),
                empName: newUserData.employee_name ?? "",
                bcNo: newUserData.bc_no ?? "",
                bcDesc: newUserData.costcenter_name ?? "",
                workArea: newUserData.workarea ?? "",
              },
            ]}
            tableHeaderLabel={[
              "_30 ",
              "Ticket No_40",
              "Employee Name_100",
              "BC No._60",
              "BC Description_100",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderBCDetails1 = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>BC List</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <MultiSelects
            value={selectedBC}
            isDisabled='true'
            isMandatory
            className={clsx(styles.select, styles.sel2)}
            isMulti
            isClearable
            options={existingBC}
            name="city"
          />
        </Grid>
      </Grid>
    </div>
  );

  const accessControlSupInfo = async() => {
    setLoadingTruck(true)
    if (dropDownValue.value === "SUP") {
      // debugger
      if (eDetails.length === 6) {
        const data = {
          pers_no: sanitizeNumeric(eDetails),
          trans_pers_no: "",
          operation_flag: "AA",
          suboperation_flag: requestType,
          erole: dropDownValue.value,
        };
        try {
          const response = await apiService.GetAdditionalAccessRequestDetails(data, dispatchNew)
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          let lowercaseMsg = response?.msg.toLowerCase();
          if (lowercaseMsg === "fail") {
            setLoadingTruck(false)
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: response?.data,
              reloads: true,
            });
          } else {
            if(lowercaseMsg === "success"){
              setLoadingTruck(false)
            }
            let noBCHead=false
            let noBcHeadName=false
            if(response?.data){ 
              noBCHead =response?.data[0]?.bc_head_pers_no==null
              noBcHeadName=response?.data[0]?.bc_head_name==null
            }
            
            if(noBCHead || noBcHeadName){
              setLoadingTruck(false)
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: 'No Approving Authority request you to contact SBP team',
              });
              setDisableButton(true)
            setEmp_app_details(response?.data);
            setEmp_app_details_status(response?.msg);
            }
             else{
              setEmp_app_details(response?.data);
               setEmp_app_details_status(response?.msg);
            
            }
          }
        } catch (error) {
          setLoadingTruck(false)
            dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
            console.error("Error occurred during API call: ", error);     
            // Check for 403 Forbidden status
            if (error.response && error.response?.status === 403) {
              console.error("Forbidden (403) error occurred. You may not have permission for this operation.");
              // Add your specific handling logic for 403 error here in the catch block
              dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
              return error.response.data;
              // For example, redirect to a login page or display an error message
            }
        } finally{
          setLoadingTruck(false)
        }    
      }
    }
    if (dropDownValue.value === "DS") {
      // debugger
      setLoadingTruck(true)
      if (eDetails.length == 6) {
        const data = {
          pers_no: sanitizeNumeric(eDetails),
          trans_pers_no: null,
          operation_flag: "AA",
          suboperation_flag: requestType,
          erole: dropDownValue.value,
        };
        try {
          const response = await apiService.GetAdditionalAccessRequestDetails(data, dispatchNew)
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
            let lowercaseMsg = response?.msg.toLowerCase();
            if (lowercaseMsg === "fail") {
              setLoadingTruck(false)
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: response?.data,
                reloads: true,
              });
            } else {
              if(lowercaseMsg === "success") {           
                setLoadingTruck(false)
              }
              setEmp_app_details(response?.data?.emp_details);
              setEmp_app_details_status(response?.msg);
              const bc = response?.data?.bc_details;
              const formattedData = bc.map((item) => ({
                value: item.bc_number,
                label: item.bc_details,
              }));
              setExistingBC(formattedData);
              setBCDetails(response?.data?.bc_details);
            }
        } catch (error) {
          setLoadingTruck(false)
          dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
          // Check for 403 Forbidden status
          if (error.response && error.response?.status === 403) {
            console.error("Forbidden (403) error occurred. You may not have permission for this operation.");
            // Add your specific handling logic for 403 error here in the catch block
            dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
            return error.response.data;
            // For example, redirect to a login page or display an error message
          } else {
            setLoadingTruck(false)      
          }
        }      
      }
    }
  };

  useEffect(() => {
    if (eDetails.length === 6) {
      accessControlSupInfo();
    }
    else{
      setEmp_app_details('');
      setEmp_app_details_status('');
    }
  }, [eDetails]);

  useEffect(() => {
    if (currentTicket.length === 6) {
      accessControlSupInfo();
    }
    else{
    setEmp_app_details([]);
    setNewUserData({});
    setNewAccessTicket("");
    setEmp_app_details_status();
    }
    
  }, [currentTicket]);

  useEffect(() => {
    if (newAccessTicket.length === 6) {
      accessControlSupInfo();
    }
    else{
      setEmp_app_details([]);
      setCurrentTicket("");
      setNewUserData({});
      setNewAccessTicket("");
      setEmp_app_details_status();
      setEDetails("");
    }
    
  }, [newAccessTicket]);

  var transformedSelectedBC = [];
  const [selectedBCInfo, setSelectedBCInfo] = useState([]);

  useEffect(() => {
    if (selectedBC != "") {
      transformedSelectedBC = selectedBC?.map((item) => item.value);
    
    const selectedBCInfo = transformedSelectedBC?.map((bcNumber) => {
      return BCDetails.find((bcDetail) => bcDetail.bc_number === bcNumber);
    });
    setSelectedBCInfo(selectedBCInfo);}
    else{
      setSelectedBCInfo([]);}

    }, [selectedBC]);

  useEffect(() => {
    if (selectedBCInfo.length > 0) {
      selectedBCInfo.forEach((item, index) => {
        if (item.bc_head_persno === null && item.department_head === null) {
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
             contextText: MESSAGE_TYPE.INFORMATION,
             info: `No Approving Authority for BC Number ${item.bc_number}, request you to contact SBP team`,
           });
           setSelectedBCInfo(prevState => prevState.filter((_, i) => i !== index));
           const matchingIndex = selectedBC.findIndex(bc => bc.value === item.bc_number);
           if (matchingIndex !== -1) {
            // Remove the item from selectedBC
            setSelectedBC(prevState => prevState.filter((_, i) => i !== matchingIndex));
          }
          setSelectedBCInfo(prevState => prevState.filter((_, i) => i !== index));
        }
      });
    }
  }, [selectedBCInfo]);

  const renderEmployeeDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>

        <Grid item md={10} lg={10} xs={10} sm={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket: (
                  <ValidatingTextField
                    variant="outlined"
                    size="small"
                    isDisabled='true'
                    value={eDetails}
                    name="Ticket Number"
                    inputProps={{
                      "data-testid": "remark-input",
                    }}
                    style={{ width: "100%" }}
                  />
                ),
                empName: emp_app_details[0]?.employee_name || "",
                bcNo: emp_app_details[0]?.bc_no || "",
                bcDesc: emp_app_details[0]?.costcenter_name || "",
                workArea: emp_app_details[0]?.workarea || "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_55",
              "Employee Name_140",
              "BC No_70",
              "BC Description_160",
              "Work Area_200",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const [requestId, setRequestId] = useState("");

  useEffect(() => {
    if (requestTypes=="AA-NA-DS" && requestId != ""){
      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: MESSAGE_TYPE.SUCCESS,
        info: "Request for new access of Department SPOC role created",
        dataTable:requestId.split(",")
      });
      history.push("/requestor-dashboard");
    }
    if(requestTypes=="AA-NA-SUP" && requestId != ""){
      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: MESSAGE_TYPE.SUCCESS,
        info: "Request for new access of Supervisor role created",
        dataTable:requestId.split(",")
      });
      history.push("/requestor-dashboard");
    }
  if(requestTypes=="AA-RTA-DS" && requestId != "" && newAccessTicket == "" ){
    showPopup({
      type: MESSAGE_TYPE.SUCCESS,
      contextText: MESSAGE_TYPE.SUCCESS,
      info: "Request for delete access of Department SPOC role created",
      dataTable:requestId.split(",")
    });
    history.push("/requestor-dashboard");
  }
  if(requestTypes=="AA-RTA-DS" && requestId != "" &&  newAccessTicket!= ""){
    showPopup({
      type: MESSAGE_TYPE.SUCCESS,
      contextText: MESSAGE_TYPE.SUCCESS,
      info: "Request for transfer access of Department SPOC role created",
      dataTable:requestId.split(",")
    });
    history.push("/requestor-dashboard");
  }
  if(requestTypes=="AA-RTA-SUP" && requestId != "" && newAccessTicket == ""){
      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: MESSAGE_TYPE.SUCCESS,
        info: "Request for delete access of Supervisor role created",
        dataTable:requestId.split(",")
      });
      history.push("/requestor-dashboard");
    }
    if(requestTypes=="AA-RTA-SUP" && requestId != "" && newAccessTicket!= ""){
      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: MESSAGE_TYPE.SUCCESS,
        info: "Request for transfer access of Supervisor role created",
        dataTable:requestId.split(",")
      });
      history.push("/requestor-dashboard");
    }
  }, [requestId,history, requestTypes]);

  const [requestNumber, setRequestNumber] = useState([]);

  useEffect(() => {
    if (dropDownValue.value === "DS") {
      const ticketNumbers = requestId
        .split(",")
        .map((item) => item.trim().split("-")[1])
        .filter((item) => item !== undefined);
      setRequestNumber(ticketNumbers);
    }
  }, [requestId]);

  const renderUserRemark = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>User Remark</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <ValidatingTextField
            variant="outlined"
            size="small"
            isDisabled='true'
            value={emp_app_details[0]?.user_remark || currentUserData?.user_remark || userRemark}
            name="projectSearch"
            inputProps={{
              "data-testid": "remark-input",
            }}
            style={{ width: "100%" }}
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderSPOCRemark = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>BC Head Remark</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <ValidatingTextField
            variant="outlined"
            isDisabled='true'
            size="small"
            value={emp_app_details[0]?.bc_remark || currentUserData?.bc_remark || bcRemark}
            name="projectSearch"
            inputProps={{
              "data-testid": "remark-input",
            }}
            style={{ width: "100%" }}
          />
        </Grid>
      </Grid>
    </div>
  );
  const renderSuperAdminRemark = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Super Admin Remark</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <ValidatingTextField
            variant="outlined"
            size="small"
            isDisabled='true'
            // value={SARemark}
            value={emp_app_details[0]?.admin_remark || currentUserData?.admin_remark}
            name="projectSearch"
            inputProps={{
              "data-testid": "remark-input",
            }}
            style={{ width: "100%" }}
          />
        </Grid>
      </Grid>
    </div>
  );

  useEffect(() => {
    if (resetAllVisitedFields);
  }, [resetAllVisitedFields]);


  let Bflag=accessRole.includes("B")
  let saFlag=accessRole.includes("SA")

  const RedirectToDashboard = () => {
      if (requestType == "PL" ) {
        dispatchNew(setLogin({ ...auth, apiSendData: apiPayloadData}));
        history.push("/linkage-dashboard");
      }
      else if(requestType == "NA" || requestType == "RTA") {
        dispatchNew(setLogin({ ...auth, apiSendData: apiPayloadData}));
        history.push("/requestor-dashboard")
      }
  } 

  return (
    <>
      {loadingTruck ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>):
               myState.tabelFlag && (

          <>{tableData.length > 0 && renderReport()}</>
        )}
    
        <Grid container spacing={0}>
            <Grid item md={1} lg={1} xs={1} sm={1} style={{marginRight: '-35px'}}> 
                <ArrowCircleLeftIcon 
                  style={{
                    fontSize:'40px', 
                    color: "#608FC9", 
                    margin: '-4px 0px 1px 10px',
                    cursor: 'pointer'
                  }} 
                  onClick={() => RedirectToDashboard()}
                />
            </Grid>
            <Grid item md={11} lg={11} xs={11} sm={11}> 
              <CustomFormGroup
                header="Additional Role Access"
                // body={renderroledetails()}
              />
            </Grid>
          </Grid>
          {renderroledetails()}

      {requestType === "" ? null : requestType === "NA" &&
        request_type.requestType === undefined && dropDownValue.length !==0 ? (
        <>
          {renderEmployeeDetails()}
          {dropDownValue.value === "DS" &&
            emp_app_details_status === "Success" && <>{renderBCDetails1()}</>}
        </>
      ) : requestType === "" ? null : requestType === "NA" &&
        request_type.requestType !== undefined ? (
        <>
          {renderTicketEmpDetails()}
          {requestRole === "DS" && <>{renderTicketBcDetails()}</>}
          {requestRole === "SUP" && <>{renderDetails()}</>}
          {renderUserRemark()}          
          {renderSPOCRemark()}
          {renderSuperAdminRemark()}
          </>
          ) : '' }

      {requestType === "" ? null : requestType === "RTA" &&
        request_type.requestType === undefined && dropDownValue.length !==0 ? (
        <>
          {renderOther1()}
          
          {dropDownValue !== undefined && dropDownValue.value === "DS" &&
            emp_app_details_status === "Success" && <>{renderBCDetails1()}</>}
        </>
      ) : requestType === "" ? null : requestType === "RTA" &&
        request_type.requestType !== undefined ? (
        <>
          {renderTransferEmpDetails()}
          {requestRole === "DS" && <>{renderTicketBcDetails()}</>}
          {requestRole === "SUP" && <>{renderTicketApprovalDetailsDelete()}</>}
          {renderUserRemark()}
          {renderSPOCRemark()}
          {renderSuperAdminRemark()}
        </>
      ) : null}

      {requestType === "NA" &&
        emp_app_details_status === "Success" &&
        dropDownValue.value === "DS" && 
        selectedBCInfo.length !== 0 &&  (
          <>{renderSpocApproval()}</>
        )}
      {requestType === "NA" &&
        emp_app_details_status === "Success" &&
        dropDownValue.value === "SUP" && (
          <>{renderDetails()}</>
        )}
      {requestType === "RTA" &&
        emp_app_details_status === "Success" &&
        currentTicket !== "" &&
        newAccessTicket === "" && (
          <>
            {dropDownValue.value === "DS" && selectedBCInfo?.length !== 0
              ? renderSpocApproval()
              : dropDownValue.value === "DS"
              ? null
              : renderApprovalDetailsDelete()}
          </>
        )}

      {requestType === "RTA" &&
        emp_app_details_status === "Success" &&
        currentTicket !== "" &&
        newAccessTicket !== "" && (
          <>
            {dropDownValue.value === "DS" && selectedBCInfo.length !== 0
              ? renderSpocApproval()
              : dropDownValue.value === "DS" && selectedBCInfo.length === 0
              ? null
              : renderApprovalDetailsDelete()}
          </>
        )}
      {request_type.requestType === undefined &&
      emp_app_details_status === "Success" ? (
        <>
          {renderUserRemark()}
          {renderSPOCRemark()}
          {renderSuperAdminRemark()}
        </>
      ) : null}

    </>
  );
}

AccessControlForm.propTypes = {
  redirectToProcessPage: PropTypes.func,
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
AccessControlForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(AccessControlForm);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);